import { useEffect, useState } from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

const BackendStatusBanner = () => {
  const [isOnline, setIsOnline] = useState(true);
  const [checking, setChecking] = useState(false);

  const checkBackend = async () => {
    setChecking(true);
    try {
      const response = await fetch('/api', { method: 'GET' });
      setIsOnline(response.ok);
    } catch {
      setIsOnline(false);
    } finally {
      setChecking(false);
    }
  };

  useEffect(() => {
    checkBackend();

    if (isOnline) return undefined;

    const interval = setInterval(checkBackend, 5000);
    return () => clearInterval(interval);
  }, [isOnline]);

  if (isOnline) return null;

  return (
    <div className="mb-4 rounded-xl border border-red-300 bg-red-50 px-4 py-3 text-red-800 dark:border-red-700 dark:bg-red-950/40 dark:text-red-200">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <AlertCircle className="mt-0.5 h-5 w-5 shrink-0" />
          <div>
            <p className="font-semibold">Backend is not running</p>
            <p className="mt-1 text-sm">
              Admin API needs backend on port 3002. Run this command:
            </p>
            <code className="mt-2 block rounded-lg bg-red-100 px-3 py-2 text-xs dark:bg-red-900/40">
              cd C:\001work\firstApp\Haseena\news\admin
              <br />
              npm run dev:full
            </code>
          </div>
        </div>
        <button
          type="button"
          onClick={checkBackend}
          disabled={checking}
          className="inline-flex items-center justify-center gap-2 rounded-lg border border-red-300 bg-white px-3 py-2 text-sm font-medium hover:bg-red-100 disabled:opacity-50 dark:border-red-700 dark:bg-red-900/30 dark:hover:bg-red-900/50"
        >
          <RefreshCw className={`h-4 w-4 ${checking ? 'animate-spin' : ''}`} />
          Retry
        </button>
      </div>
    </div>
  );
};

export default BackendStatusBanner;
